import React from 'react';
import { css } from '@bd/bdui-styles/emotion';
import { Sticky } from '@bd/bdcore-utilities';
import PageMenu from './PageMenu';

const styles = css`
  width: 100%;
  height: auto;
  transition: all .3s ease-out;
  @media(min-width: 992px) {
    top: 0 !important;
    padding: 0;
    position: relative !important;
  }
  @supports(position: sticky) {
    top: 59px !important;
    z-index: 10 !important;
    position: sticky !important;
    @media(min-width: 992px) {
      top: 100px !important;
    }
  }
`;

const MenuAbout = () => {
  return (
    <Sticky className={styles}>
      <PageMenu
        title="Page Menu"
        items={[
          {
            name: 'about-us',
            title: 'About Us',
          },
          {
            name: 'core-principles',
            title: 'Core Principles',
          },
          {
            // name: 'meet-the-team',
            // title: 'Meet The Team',
          },
          // {
          //   name: 'blog',
          //   title: 'Blog',
          // },
          {
            name: 'testimonials',
            title: 'Testimonials',
          },
        ]}
      />
    </Sticky>
  );
};

export default MenuAbout;



// WEBPACK FOOTER //
// ./src/components/MenuAbout.js